import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import ImagesGallery from "./generalComponents/ImagesGallery";
import Details from "./generalComponents/Details";

export default function UnpublishedPackages() {
  const [packages, setPackages] = useState([]);
  const [packagesDocsReady, setPackageDocsReady] = useState(false);
  const [packagesId, setPackagesId] = useState([]);
  const status = "unpublished";

  // const hostname = window.location.hostname;
  const navigate = useNavigate();
  // const navigate = useNavigate();

  // const packagesLocation = query(collection(db, `packages/${user}`))
  useEffect(() => {
    (async () => {
      const colRef = collection(db, "packages");
      const q = query(colRef, where("adminPublish", "==", "false"));
      const snapshots = await getDocs(q);
      const docs = snapshots.docs.map((doc) => doc.data());
      // const proIDs = snapshots.docs.map((doc) => doc.data().user);

      const docsId = snapshots.docs.map((doc) => doc.id);
      setPackagesId(docsId);
      setPackages(docs);
      // setUserIDs(new Set(proIDs));
      setPackageDocsReady(true);
    })();
  }, []);

  useEffect(() => {
    console.log("Packages ID: ", packagesId);
    console.log("Packages: ", packages);
  });

  return (
    <>
      <h1
        data-cy="heading-packages"
        className="text-center md:text-2x text-xl md:py-10 py-5 bg-gray-100"
      >
        Unpublished Admin: Photography & Videography
      </h1>
      {packages && (
        <div data-cy="main-div" className="w-full bg-gray-100 px-2 pb-10">
          <div className="mx-auto grid w-full lg:w-10/12 flex-col gap-2 md:grid-cols-2">
            {packages.map((packageSolo, index) => {
              return (
                <div
                  data-cy="packages-divs"
                  className="cursor-pointer h-96 divide-y divide-gray-600 z-0 relative bg-white shadow rounded-md hover:border-orange-400"
                  onClick={() =>
                    navigate(
                      `/packagesadmin/unpublished/${packageSolo.nameUrl}`
                    )
                  }
                  key={packageSolo.name}
                >
                  <div
                    className={`${
                      status === "published" ? "bg-green-500" : "bg-red-500"
                    } absolute z-10 p-4 opacity-80 top-1/4 text-xs`}
                  >
                    <p>Package ID: {packagesId[index]}</p>
                    <p>
                      Created At:{" "}
                      {packageSolo.createdAt.toDate().toDateString()}{" "}
                      {packageSolo.createdAt
                        .toDate()
                        .toLocaleTimeString("en-ZA")}
                    </p>
                    {packageSolo.updatedAt ? (
                      <p>
                        Updated At:{" "}
                        {packageSolo.updatedAt?.toDate().toDateString()}{" "}
                        {packageSolo.updatedAt
                          ?.toDate()
                          .toLocaleTimeString("en-ZA")}
                      </p>
                    ) : (
                      "No update"
                    )}

                    {status === "unpublished" && (
                      <>
                        <p>User Publish: {packageSolo.userPublish}</p>
                        <p>Admin Publish: {packageSolo.adminPublish}</p>
                      </>
                    )}
                  </div>
                  {/* <div className="absolute">Hello</div> */}
                  <ImagesGallery
                    packageSolo={packageSolo}
                    packagesDocsReady={packagesDocsReady}
                    packageId={packagesId[index]}
                    status={status}
                  />
                  <Details
                    packageSolo={packageSolo}
                    packagesDocsReady={packagesDocsReady}
                    packageId={packagesId[index]}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
